import { PricingType } from "../../types";

/** A single not-yet-posted visit in a case's "care team". */
export interface VisitDraft {
  /** Stable local id so drafts can be edited/removed and de-duplicated on retry. */
  id: string;
  visitType: string;
  workerRequirement: string;
  pricingType: PricingType;
  visitsPerWeek: string;
  totalWeeks: string;
  firstVisitDueDate: string;
  estimatedDuration: string;
  hasFixedStartTime: boolean;
  estimatedStartTime: string;
  hasSpecificDaysOfWeek: boolean;
  daysOfWeek: string[];
  chargePerVisit: string;
  payPerVisit: string;
}

export type VisitDraftFields = Omit<VisitDraft, "id">;

export type VisitDraftFieldValue = VisitDraftFields[keyof VisitDraftFields];

export const DEFAULT_VISIT_DRAFT_FIELDS: VisitDraftFields = {
  visitType: "",
  workerRequirement: "",
  pricingType: PricingType.PER_VISIT,
  visitsPerWeek: "",
  totalWeeks: "",
  firstVisitDueDate: "",
  estimatedDuration: "",
  hasFixedStartTime: false,
  estimatedStartTime: "",
  hasSpecificDaysOfWeek: false,
  daysOfWeek: [],
  chargePerVisit: "",
  payPerVisit: "",
};

export function createVisitDraft(
  fields: VisitDraftFields = DEFAULT_VISIT_DRAFT_FIELDS
): VisitDraft {
  return { id: `visit-draft-${crypto.randomUUID()}`, ...fields };
}
